// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-body {
  background-repeat: no-repeat;
  background-image: url('psa-bdp-login-background.0bd7f1b891e1042b.png');
  background-size: cover;
  height: auto;
  min-height: 100vh;
  background-attachment: fixed;
}
.login-body .login-wrapper {
  height: auto;
  min-height: 100vh;
}
.login-body .login-wrapper .login-panel {
  flex-direction: row;
  background-color: #EBF2FF;
  width: 500px;
  color: black;
  height: 535px;
  border-radius: 6px;
  padding: 34px 40px 52px 40px;
}
.login-body .login-wrapper .login-panel.bdp-forget-password {
  height: 350px;
}
.login-body .login-wrapper .login-panel.bdp-reset-password {
  height: 525px;
}
.login-body .login-wrapper .login-panel.bdp-confirm-password {
  height: 375px;
}
.login-body .login-wrapper .login-panel.bdp-reset-password-auth {
  height: 450px;
}
.login-body .login-wrapper .login-panel.bdp-register {
  width: 100%;
  max-width: 904px;
  height: -moz-fit-content;
  height: fit-content;
  padding: 40px 40px;
  margin: 48px 0px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .p-inputtext-lg {
  display: flex;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .bdp-logo-wrapper {
  margin-bottom: 0px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form h5.bdp-sub-heading {
  font-size: 18px;
  margin-top: 36px;
  text-align: left;
  font-weight: 500;
  margin-bottom: -12px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form h6.bdp-sub-heading {
  font-size: 16px;
  color: black;
  margin-top: 15px;
  text-align: left;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .bdp-bottom-text {
  color: black;
  margin-top: 10px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .p-button {
  width: 50%;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .bdp-form-error {
  color: red;
  position: absolute;
  margin-top: 4px;
  text-align: left;
  left: 0;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form .bdpPhoneErrorMsg {
  top: 75px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form #otherIndustryName {
  margin-top: 10px;
}
.login-body .login-wrapper .login-panel.bdp-register .login-form #phoneNumber {
  margin-left: 2px;
}
.login-body .login-wrapper .login-panel .login-form {
  height: 95%;
  width: 100%;
}
.login-body .login-wrapper .login-panel .login-form .bdp-logo-wrapper {
  width: 384px;
  display: block;
  background-image: url('PSA BDP_Black.3725965d40a97619.png');
  height: 62px;
  background-position: center;
  margin-left: auto;
  margin-right: auto;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 40px;
  margin-top: 30px;
}
.login-body .login-wrapper .login-panel .login-form .bdp-sub-heading {
  font-size: 14px;
  color: black;
}
.login-body .login-wrapper .login-panel .login-form .p-input-icon-right {
  width: 100%;
}
.login-body .login-wrapper .login-panel .login-form .bdp-row-wrapper .p-input-icon-right {
  width: 49%;
}
.login-body .login-wrapper .login-panel .login-form .bdp-row-wrapper .p-input-icon-right:nth-child(1) {
  margin-right: 1%;
}
.login-body .login-wrapper .login-panel .login-form .bdp-row-wrapper .p-input-icon-right:nth-child(2) {
  margin-left: 1%;
}
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg {
  margin: 32px 0px;
  margin-top: 16px;
}
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg label {
  width: 100%;
  float: left;
  text-align: left;
  margin-bottom: 8px;
  color: black;
  opacity: 0;
  height: 4px;
}
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext {
  width: 100%;
  text-align: left;
  color: black;
  background-color: #EBF2FF;
  font-size: 16px;
  border: 1px solid black;
  height: 48px;
  padding-left: 12px;
  margin-top: -1px;
}
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext.p-error,
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext.p-invalid,
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext.ng-dirty.ng-invalid,
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext.p-component.ng-touched.ng-invalid.ng-pristine {
  border: 1px solid #f44336;
}
.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .pi {
  margin-top: 0px;
  margin-right: 10px;
  cursor: pointer;
}
.login-body .login-wrapper .login-panel .login-form .phone {
  width: 100% !important;
}
.login-body .login-wrapper .login-panel .login-form img.flag {
  width: 28px;
  margin-right: 6px;
  margin-bottom: 2px;
}
.login-body .login-wrapper .login-panel .login-form .p-button {
  width: 100%;
  height: 48px;
  max-width: 100%;
  margin: 10px 0px;
}
.login-body .login-wrapper .login-panel .login-form .bdp-forgot-password {
  float: right;
  text-decoration: underline;
  color: #206bff;
  font-size: 14px;
  text-align: right;
  margin-top: 8px;
}
.login-body .login-wrapper .login-panel .login-form p-checkbox {
  float: left;
  width: 100%;
  margin: 13px 0px;
}
.login-body .login-wrapper .login-panel .login-form .bdp-bottom-heading {
  color: black;
  margin-top: 24px;
  width: 100%;
  display: block;
  float: left;
  margin-bottom: 0px;
}
.login-body .login-wrapper .login-panel .login-form a {
  color: #206bff;
  text-decoration: underline;
}
.login-body .login-wrapper .login-panel .login-form .loginProgress {
  padding-top: 6rem;
  padding-bottom: 1rem;
}
.login-body .login-wrapper .login-panel ::ng-deep #phoneCode .p-dropdown .p-dropdown-label {
  width: 100%;
  height: 48px;
  padding: 11px 8px;
}
.login-body .login-wrapper .login-panel ::ng-deep #phoneCode .p-dropdown .p-dropdown-label .country-item {
  display: -webkit-inline-box;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown {
  background: #EBF2FF !important;
  outline: none !important;
  border: 1px solid black;
  width: 100%;
  height: 48px;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown .p-dropdown-label {
  color: black;
  text-align: left;
  padding-top: 0.8rem;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: black;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  text-align: left;
  white-space: inherit;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown .p-dropdown-panel {
  width: 267px;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  width: 100%;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-inputnumber {
  width: inherit;
}
.login-body .login-wrapper .login-panel ::ng-deep .p-inputnumber .p-inputnumber-input {
  width: 100%;
  text-align: left;
  color: black;
  background-color: #EBF2FF;
  font-size: 16px;
  border: none;
  height: 48px;
  padding-left: 12px;
  margin-top: -1px;
  margin-left: 4px;
}
.login-body .login-wrapper .login-panel ::ng-deep .bdp-invalid .p-dropdown,
.login-body .login-wrapper .login-panel ::ng-deep .bdp-invalid .p-inputnumber-input {
  border: 1px solid #f44336;
}
.login-body ::ng-deep .p-progressbar .p-progressbar-value {
  background-color: #206bff !important;
}

.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext::placeholder {
  color: black;
}

.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext:-moz-placeholder {
  color: black;
  opacity: 1;
}

.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext::-moz-placeholder {
  color: black;
  opacity: 1;
}

:host ::ng-deep .custom-spinner .p-progress-spinner-circle {
  animation: custom-progress-spinner-dash 1.5s ease-in-out infinite, custom-progress-spinner-color 6s ease-in-out infinite;
}

@keyframes custom-progress-spinner-color {
  100%, 0% {
    stroke: #16697a;
  }
  40% {
    stroke: #489fb5;
  }
  66% {
    stroke: #82c0cc;
  }
  80%, 90% {
    stroke: #ffa62b;
  }
}
@keyframes custom-progress-spinner-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
.backIcon {
  color: black !important;
  float: left !important;
  text-decoration: none !important;
  font-size: 16px;
  position: relative;
  bottom: 12px;
  right: 12px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/air/pages/auth/auth.component.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EAGA,sEAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AADJ;AAGI;EACI,YAAA;EACA,iBAAA;AADR;AAGQ;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;AADZ;AAGY;EACI,aAAA;AADhB;AAIY;EACI,aAAA;AAFhB;AAKY;EACI,aAAA;AAHhB;AAMY;EACI,aAAA;AAJhB;AAOY;EACI,WAAA;EAEA,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,gBAAA;AANhB;AASoB;EAEI,aAAA;AARxB;AAWoB;EACI,kBAAA;AATxB;AAYoB;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAVxB;AAaoB;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAXxB;AAcoB;EACI,YAAA;EACA,gBAAA;AAZxB;AAeoB;EACI,UAAA;AAbxB;AAeoB;EACI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;AAbxB;AAeoB;EACI,SAAA;AAbxB;AAeoB;EACI,gBAAA;AAbxB;AAeoB;EACI,gBAAA;AAbxB;AAkBY;EACI,WAAA;EACA,WAAA;AAhBhB;AAkBgB;EACI,YAAA;EACA,cAAA;EAEA,2DAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAjBpB;AAoBgB;EACI,eAAA;EACA,YAAA;AAlBpB;AAqBgB;EACI,WAAA;AAnBpB;AAuBoB;EACI,UAAA;AArBxB;AAuBwB;EACI,gBAAA;AArB5B;AAwBwB;EACI,eAAA;AAtB5B;AA2BgB;EACI,gBAAA;EACA,gBAAA;AAzBpB;AA2BoB;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAzBxB;AA4BoB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA1BxB;AA4BoB;;;;EAII,yBAAA;AA1BxB;AA4BoB;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AA1BxB;AA8BgB;EACI,sBAAA;AA5BpB;AA8BgB;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;AA5BpB;AA8BgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA5BpB;AA+BgB;EACI,YAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA7BpB;AAgCgB;EACI,WAAA;EACA,WAAA;EACA,gBAAA;AA9BpB;AAiCgB;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AA/BpB;AAkCgB;EACI,cAAA;EACA,0BAAA;AAhCpB;AAmCgB;EACI,iBAAA;EACA,oBAAA;AAjCpB;AAuCoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AArCxB;AAsCwB;EACI,2BAAA;AApC5B;AAwCgB;EACI,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAtCpB;AAwCgB;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;AAtCpB;AAwCgB;EACI,YAAA;AAtCpB;AAwCgB;EACI,gBAAA;EACA,oBAAA;AAtCpB;AAwCgB;EACI,YAAA;AAtCpB;AAwCgB;EACI,WAAA;AAtCpB;AAwCgB;EACI,cAAA;AAtCpB;AAuCoB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AArCxB;AAyCoB;;EAEI,yBAAA;AAvCxB;AA+CI;EACI,oCAAA;AA7CR;;AAgDA;EACI,YAAA;AA7CJ;;AA+CA;EAAoG,YAAA;EAAc,UAAA;AA1ClH;;AA2CA;EAAqG,YAAA;EAAc,UAAA;AAtCnH;;AAuCA;EACI,wHAAA;AApCJ;;AAwCA;EACI;IAEI,eAAA;EAtCN;EAwCE;IACI,eAAA;EAtCN;EAwCE;IACI,eAAA;EAtCN;EAwCE;IAEI,eAAA;EAvCN;AACF;AA0CA;EACI;IACI,wBAAA;IACA,oBAAA;EAxCN;EA0CE;IACI,yBAAA;IACA,wBAAA;EAxCN;EA0CE;IACI,yBAAA;IACA,yBAAA;EAxCN;AACF;AA2CA;EACI,uBAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAzCJ;;AA2CA;;EAEI,wBAAA;EACA,SAAA;AAxCJ","sourcesContent":[".login-body {\n    background-repeat: no-repeat;\n    // background-position: center;\n    // background-image: url(\"../../../assets/layout/images/login-bg.png\");\n    background-image: url(\"../../../../assets/layout/images/psa-bdp-login-background.png\");\n    background-size: cover;\n    height: auto;\n    min-height: 100vh;\n    background-attachment: fixed;\n\n    .login-wrapper {\n        height: auto;\n        min-height: 100vh;\n\n        .login-panel {\n            flex-direction: row;\n            background-color: #EBF2FF;\n            width: 500px;\n            color: black;\n            height: 535px;\n            border-radius: 6px;\n            padding: 34px 40px 52px 40px;\n\n            &.bdp-forget-password {\n                height: 350px;\n            }\n\n            &.bdp-reset-password {\n                height: 525px;\n            }\n\n            &.bdp-confirm-password {\n                height: 375px;\n            }\n\n            &.bdp-reset-password-auth {\n                height: 450px;\n            }\n\n            &.bdp-register {\n                width: 100%;\n                // max-width: 845px;\n                max-width: 904px;\n                height: fit-content;\n                padding: 40px 40px;\n                margin: 48px 0px;\n\n                .login-form {\n                    .p-inputtext-lg {\n                        // margin: 16px 0px;\n                        display: flex;\n                    }\n\n                    .bdp-logo-wrapper {\n                        margin-bottom: 0px;\n                    }\n\n                    h5.bdp-sub-heading {\n                        font-size: 18px;\n                        margin-top: 36px;\n                        text-align: left;\n                        font-weight: 500;\n                        margin-bottom: -12px;\n                    }\n\n                    h6.bdp-sub-heading {\n                        font-size: 16px;\n                        color: black;\n                        margin-top: 15px;\n                        text-align: left;\n                    }\n\n                    .bdp-bottom-text {\n                        color: black;\n                        margin-top: 10px;\n                    }\n\n                    .p-button {\n                        width: 50%;\n                    }\n                    .bdp-form-error {\n                        color: red;\n                        position: absolute;\n                        margin-top: 4px;\n                        text-align: left;\n                        left: 0;\n                    }\n                    .bdpPhoneErrorMsg {\n                        top: 75px;\n                    }\n                    #otherIndustryName {\n                        margin-top: 10px;\n                    }\n                    #phoneNumber {\n                        margin-left: 2px;\n                    }\n                }\n            }\n\n            .login-form {\n                height: 95%;\n                width: 100%;\n\n                .bdp-logo-wrapper {\n                    width: 384px;\n                    display: block;\n                    // background-image: url('../../../assets/layout/images/BDP Logo White.png');\n                    background-image: url(\"../../../../assets/layout/images/PSA BDP_Black.png\");\n                    height: 62px;\n                    background-position: center;\n                    margin-left: auto;\n                    margin-right: auto;\n                    background-repeat: no-repeat;\n                    background-size: cover;\n                    margin-bottom: 40px;\n                    margin-top: 30px;\n                }\n\n                .bdp-sub-heading {\n                    font-size: 14px;\n                    color: black;\n                }\n\n                .p-input-icon-right {\n                    width: 100%;\n                }\n\n                .bdp-row-wrapper {\n                    .p-input-icon-right {\n                        width: 49%;\n\n                        &:nth-child(1) {\n                            margin-right: 1%;\n                        }\n\n                        &:nth-child(2) {\n                            margin-left: 1%;\n                        }\n                    }\n                }\n\n                .p-inputtext-lg {\n                    margin: 32px 0px;\n                    margin-top: 16px;\n\n                    label {\n                        width: 100%;\n                        float: left;\n                        text-align: left;\n                        margin-bottom: 8px;\n                        color: black;\n                        opacity: 0;\n                        height: 4px;\n                    }\n\n                    .p-inputtext {\n                        width: 100%;\n                        text-align: left;\n                        color: black;\n                        background-color: #EBF2FF;\n                        font-size: 16px;\n                        border: 1px solid black;\n                        height: 48px;\n                        padding-left: 12px;\n                        margin-top: -1px;\n                    }\n                    .p-inputtext.p-error,\n                    .p-inputtext.p-invalid,\n                    .p-inputtext.ng-dirty.ng-invalid,\n                    .p-inputtext.p-component.ng-touched.ng-invalid.ng-pristine {\n                        border: 1px solid #f44336;\n                    }\n                    .pi {\n                        margin-top: 0px;\n                        margin-right: 10px;\n                        cursor: pointer;\n                    }\n                }\n\n                .phone {\n                    width: 100% !important;\n                }\n                img.flag {\n                    width: 28px;\n                    margin-right: 6px;\n                    margin-bottom: 2px;\n                }\n                .p-button {\n                    width: 100%;\n                    height: 48px;\n                    max-width: 100%;\n                    margin: 10px 0px;\n                }\n\n                .bdp-forgot-password {\n                    float: right;\n                    text-decoration: underline;\n                    color: #206bff;\n                    font-size: 14px;\n                    text-align: right;\n                    margin-top: 8px;\n                }\n\n                p-checkbox {\n                    float: left;\n                    width: 100%;\n                    margin: 13px 0px;\n                }\n\n                .bdp-bottom-heading {\n                    color: black;\n                    margin-top: 24px;\n                    width: 100%;\n                    display: block;\n                    float: left;\n                    margin-bottom: 0px;\n                }\n\n                a {\n                    color: #206bff;\n                    text-decoration: underline;\n                }\n\n                .loginProgress {\n                    padding-top: 6rem;\n                    padding-bottom: 1rem;\n                }\n            }\n\n            ::ng-deep {\n                #phoneCode {\n                    .p-dropdown .p-dropdown-label {\n                        width: 100%;\n                        height: 48px;\n                        padding: 11px 8px;\n                        .country-item {\n                            display: -webkit-inline-box;\n                        }\n                    }\n                }\n                .p-dropdown {\n                    background: #EBF2FF !important;\n                    outline: none !important;\n                    border: 1px solid black;\n                    width: 100%;\n                    height: 48px;\n                }\n                .p-dropdown .p-dropdown-label {\n                    color: black;\n                    text-align: left;\n                    padding-top: 0.8rem;\n                }\n                .p-dropdown .p-dropdown-label.p-placeholder{\n                    color: black;\n                }\n                .p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n                    text-align: left;\n                    white-space: inherit;\n                }\n                .p-dropdown .p-dropdown-panel {\n                    width: 267px;\n                }\n                .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n                    width: 100%;\n                }\n                .p-inputnumber {\n                    width: inherit;\n                    .p-inputnumber-input {\n                        width: 100%;\n                        text-align: left;\n                        color: black;\n                        background-color: #EBF2FF;\n                        font-size: 16px;\n                        border: none;\n                        height: 48px;\n                        padding-left: 12px;\n                        margin-top: -1px;\n                        margin-left: 4px;\n                    }\n                }\n                .bdp-invalid {\n                    .p-dropdown,\n                    .p-inputnumber-input {\n                        border: 1px solid #f44336;\n                    }\n                }\n               \n            }\n\n        }\n    }\n    ::ng-deep .p-progressbar .p-progressbar-value {\n        background-color: #206bff !important;\n    }\n}\n.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext::placeholder{\n    color: black;\n}\n.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext:-moz-placeholder { color: black; opacity:1;}\n.login-body .login-wrapper .login-panel .login-form .p-inputtext-lg .p-inputtext::-moz-placeholder { color: black; opacity:1;}\n:host ::ng-deep .custom-spinner .p-progress-spinner-circle {\n    animation: custom-progress-spinner-dash 1.5s ease-in-out infinite,\n        custom-progress-spinner-color 6s ease-in-out infinite;\n}\n\n@keyframes custom-progress-spinner-color {\n    100%,\n    0% {\n        stroke: #16697a;\n    }\n    40% {\n        stroke: #489fb5;\n    }\n    66% {\n        stroke: #82c0cc;\n    }\n    80%,\n    90% {\n        stroke: #ffa62b;\n    }\n}\n\n@keyframes custom-progress-spinner-dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }  \n}\n\n.backIcon {\n    color: black !important;\n    float: left !important;\n    text-decoration: none !important;\n    font-size: 16px;\n    position: relative;\n    bottom: 12px;\n    right: 12px;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
